const DownloadIcon = (props: { color?: string; primary?: boolean; style?: React.CSSProperties }) => {
  const { style, color, primary } = props;
  let c = "#ffffff";
  if (primary) c = "#1062D0";
  if (color) c = color;

  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
    >
      <g clipPath="url(#a)">
        <path
          d="M13.246 10.127a.834.834 0 0 0-.746-.46h-1.667V1.333a.833.833 0 1 0-1.666 0v8.334H7.5A.834.834 0 0 0 6.833 11l2.5 3.333c.011.014.028.02.04.033.055.065.12.115.192.16.03.019.053.043.086.058.107.05.223.083.35.083a.825.825 0 0 0 .35-.083c.03-.015.055-.04.084-.057a.813.813 0 0 0 .193-.161c.01-.014.028-.018.039-.033l2.5-3.333c.19-.252.22-.59.079-.873Z"
          fill={c}
        />
        <path
          d="M19.167 13a.833.833 0 0 0-.834.833v2.5c0 1.379-1.121 2.5-2.5 2.5H4.167a2.503 2.503 0 0 1-2.5-2.5v-2.5a.833.833 0 1 0-1.667 0v2.5A4.171 4.171 0 0 0 4.167 20.5h11.666A4.171 4.171 0 0 0 20 16.333v-2.5a.833.833 0 0 0-.833-.833Z"
          fill={c}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DownloadIcon;
